import { Expose } from 'class-transformer';

export default class AvailabilityCheckFormError {
    start_at: string[] = []
    end_at: string[] = []
    lunch_break: string[] = []
    postcode: string[] = []
    lat: string[] = []
    lng: string[] = []
    practice_name: string[] = []
    payment_option: string[] = []
    settlement_days: string[] = []
    role: string[] = []
    tiers: string[] = []
    sedation_required: string[] = []
    radiography_required: string[] = []
    implant_required: string[] = []
    orthodontics_required: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}